module.exports = __webpack_public_path__ + "img/ring_g_l_0_1@3x.3c36280c.png";